import API from './api';

export interface LoginCredentials {
  email: string;
  password: string;
}

export interface User {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  role: 'DOCUMENTER' | 'RESEARCHER' | 'APPROVER' | 'ADMIN';
  organization?: string;
  profilePicture?: string | null;
  countries?: string[];
  lastLogin?: string | null;
}

export interface AuthResponse {
  user: User;
  token: string;
}

class AuthService {
  async login(credentials: LoginCredentials): Promise<AuthResponse> {
    const response = await API.post('/api/auth/login', credentials);
    return response.data;
  }

  async register(userData: any): Promise<AuthResponse> {
    const response = await API.post('/api/auth/register', userData);
    return response.data;
  }

  async logout(): Promise<void> {
    await API.post('/api/auth/logout');
    localStorage.removeItem('token');
    localStorage.removeItem('user');
  }

  getCurrentUser(): User | null {
    const userStr = localStorage.getItem('user');
    if (userStr) {
      try {
        return JSON.parse(userStr);
      } catch {
        return null;
      }
    }
    return null;
  }

  isAuthenticated(): boolean {
    return !!localStorage.getItem('token');
  }
}

const authService = new AuthService();
export default authService;